import type {
  IAdapterConfig,
  MiddlewareConfigClass
} from '@care-portals/api-interfaces';

const config = {
  tmc: {
    label: 'TMC Pharmacy',
    functions: {
      CreateOrder: {
        middlewareHandler: 'tmc',
        version: 2,
        label: 'Create Order',
        pipelines: ['order'],
        passPayload: true,
        params: []
      },
      /**
       * TMC has no webhooks, so status only advances when this is called. Support drives it from a
       * polling workflow rather than anything scheduled in code.
       */
      RetrieveOrder: {
        middlewareHandler: 'tmc',
        version: 2,
        label: 'Retrieve Order',
        pipelines: ['order'],
        passPayload: true,
        params: []
      }
    }
  }
} as const;

export const TmcConfig: IAdapterConfig = {
  ...config
} as unknown as IAdapterConfig;

export type TmcFunctionConfiguration = MiddlewareConfigClass<
  typeof config.tmc.functions
>;
